const UiMeet3dEventType = {
  FIRST_MOVE: 0,
  LEAD: 1,
  MEETING_REQUEST: 2,
};

export default UiMeet3dEventType;
